import { supabase } from './supabase';

export async function logActivity(userEmail: string | undefined, action: string, details: any = null) {
    try {
        await supabase.from('activity_logs').insert({
            user_email: userEmail || 'unknown',
            action,
            details
        });
    } catch (err) {
        console.error('Error logging activity:', err);
    }
}
